import React, {Component} from 'react';
import './list.css';
import Constant from "./constant.js"
import {changZykVideoCount, getAnalyze, getZykVideoList} from '../../actions'
import {List, Pagination, Spin} from "antd";
import {connect} from "react-redux";
import $ from "jquery";
import {HEADER_HEIGHT} from "../../constants";
import {applicationName} from "../../utils";

/* global layer, layui */
class VideoList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            count: 0,
            size: Constant.configPagesize,
            start: 1,
            loading: false,
            height: applicationName() === 'pms' ? window.innerHeight - HEADER_HEIGHT - 172 : window.innerHeight - HEADER_HEIGHT - 272,
        }
    }

    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        this.setState({
            loading: true,
        });
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }
        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": this.state.start,
            "size": this.state.size
        };

        /**
         * 查询视频列表的数据
         */
        getZykVideoList(param, this.updateVideoList.bind(this))
    }

    /**
     * 更新视频列表
     * @param result
     */
    updateVideoList(result) {

        this.props.changZykVideoCount(result.count)

        //处理前台的分页数据
        let resultData = result.data;
        this.setState({
            data: resultData,
            loading: false,
            count: result.count
        });


    }


    /**
     * 分词在页面高亮显示；
     * @param data
     */
    lightAnayWorldInList(data) {
        //按照优先级排序
        let listData = data.sort(function (a, b) {
            return b.length - a.length
        });
        //定义正则表达式对象  array[i]是关键字   "g"是指全局范围
        let a = new RegExp(listData.join("|"), "g");
        $(".content-header").each(function () {
            var html = $(this)[0].getAttribute('title')
            html = html.replace(a, function (item) {
                return "<span style='color:#F00'>" + item + "</span>"
            });
            $(this).html(html);
        });
    }

    //页面加载完毕，高亮分词
    componentDidUpdate(prevProps, prevState, snapshot) {
        console.info("vidoe_list");
        //分词处理，分词高亮显示；
        if (prevProps.tableKey === 4) {
            if (this.props.searchText) {
                let param = {
                    str: this.props.searchText
                }
                //请求后台获取分词数据
                getAnalyze(param, this.lightAnayWorldInList.bind(this));
            }else {
                $(".content-header").each(function () {
                    if ($(this).find('span')[0] && $(this).find('span')[0].style) {
                        $(this).find('span')[0].style.color = '#000';
                    }
                });
            }
        }
    }


    //插入视频文件
    insertVideo(data) {
        if (applicationName() === 'contribute') {
            let param = {
                "align": "none",
                "url": data.ZykVideo_path,
                "title": data.ZykVideo_name,
                "width": 500,
            }
            let list = []
            list.push(param);
            window.frames[0].ueditor.execCommand('insertvideo', list);

            let param2 = {
                "success": true,
                "url": data.ZykVideo_path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": 0,
                    "md5": "",
                    "name": data.ZykVideo_name,
                    "path": data.ZykVideo_path,
                    "prefix": "",
                    "size": data.ZykVideo_size,
                    "storageDirectoryId": [],
                    "suffix": data.ZykVideo_ext,
                    "type": 2,
                    "url": "",
                    "width": 500,
                },
                "state": "SUCCESS",
                "title": data.ZykVideo_name,
                "original": data.ZykVideo_name
            }
            window.frames[0].cmSitesFileUploadAfterCallbackFun(param2);
        } else {
            let param = {
                "align": "none",
                "title": data.ZykVideo_name,
                "url": data.ZykVideo_path,
                "width": 500,
            }
            let list = []
            list.push(param);
            window.parent.ueditor.execCommand('insertvideo', list);

            let param2 = {
                "success": true,
                "url": data.ZykVideo_path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": 0,
                    "md5": "",
                    "name": data.ZykVideo_name,
                    "path": data.ZykVideo_path,
                    "prefix": "",
                    "size": data.ZykVideo_size,
                    "storageDirectoryId": [],
                    "suffix": data.ZykVideo_ext,
                    "type": 2,
                    "url": "",
                    "width": 500
                },
                "state": "SUCCESS",
                "title": data.ZykVideo_name,
                "original": data.ZykVideo_name
            }
            window.parent.cmSitesFileUploadAfterCallbackFun(param2);
        }
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.tableKey === 4) {
            this.setState({
                loading: true,
                start: 1,
            })
            let onlyMe = 1;
            if (nextProps.onlyMe) {
                onlyMe = 0
            }
            let param = {
                "query": nextProps.searchText,
                "isAll": onlyMe,
                "start": 1,
                "size": this.state.size
            };
            //请求后台获取稿件列表数据
            getZykVideoList(param, this.updateVideoList.bind(this));
        }
    }


    /**
     * 视频预览功能
     * @param record
     */
    videoTopreview(record) {

        let data = {
            "mediaFusionVideo": {
                "path": record.ZykVideo_path
            },
            "title": record.ZykVideo_name
        };


        let parent;
        if (applicationName() === 'pms') {
            parent = window.parent;
        } else {
            parent = window.frames[0];
        }

        parent.layui.config({
            base: '/cm-sites/layuiadmin/modules/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(['storage'], function () {
            let content = '/cm-sites/'+window.env+'/previewMedia/video-view.html';
            var storage = parent.layui.storage;
            storage.set("current-video", data);

            parent.layer.open({
                type: 2,
                area: ['800px', '600px'],
                title: data.title,
                content: content
            });
        });
    }


    getZykAudioPageList(page, pageSize) {
        this.setState({
            loading: true
        })
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }

        this.setState({
            start: page
        })

        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": page,
            "size": pageSize,
        };
        //请求后台获取稿件列表数据
        getZykVideoList(param, this.updateVideoList.bind(this));
    }


    addHoverRemark() {
        $(".videoList").on('mouseenter', '.image-box', function () {
            $(this).find(".image-remake").animate({bottom: "0px"}, 300);
        })

        $(".videoList").on('mouseleave', '.image-box', function () {
            $(this).find(".image-remake").animate({bottom: "-35px"}, 300);
        });
    }

    componentDidMount() {
        this.addHoverRemark()
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <div className='videoList' style={{height: this.state.height + 'px', overflow: "auto"}}>
                    <List
                        itemLayout="vertical"
                        size="large"
                        dataSource={this.state.data}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    title={<div className="item-box">
                                        <div className="image-box" onClick={() => {
                                            this.insertVideo(item)
                                        }}>
                                            <img src={item.ZykVideo_path + '/thumbnails/1'}/>
                                            <div className="image-remake">
                                                插入正文
                                            </div>
                                            <p className="image-box-time">
                                                <span>{Constant.duration(item)}</span>
                                            </p>
                                        </div>
                                        <div className={"content-box content-box-" + applicationName()}>
                                            <p className="content-header video-name"
                                               title={item.ZykVideo_name}
                                            >{item.ZykVideo_name}</p>
                                            <p><span style={{cursor: 'pointer', color: "#0050B3"}}
                                                  onClick={this.videoTopreview.bind(this, item)}>预览</span></p>
                                            <p className="content-bottom">
                                                <span>来源:{Constant.getDataSource(item.ZykVideo_dataSource)}</span>
                                                <span title={item.ZykVideo_createDate}>日期:{item.ZykVideo_createDate}</span>
                                            </p>
                                        </div>
                                    </div>}
                                />
                            </List.Item>
                        )}
                    />
                </div>
                <div className='pageTables'>
                    <Pagination showLessItems={true} current={this.state.start} total={this.state.count}
                                defaultPageSize={this.state.size}
                                defaultCurrent={1}
                                onChange={(page, pageSize) => {
                                    this.getZykAudioPageList(page, pageSize)
                                }} onShowSizeChange={(page, pageSize) => {
                        this.getZykAudioPageList(page, pageSize)
                    }}/>
                </div>
            </Spin>

        );
    }
}

function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch: state.zykReducer.doSearch
    }
}


function mapStateToMethod(dispatch) {
    return {
        changZykVideoCount: function (zykStoryCount) {
            return dispatch(changZykVideoCount(zykStoryCount));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(VideoList);
